import { get, type Writable, writable } from "svelte/store"
type Settings = {
    dragging?: Writable<boolean>
    callback: (e: PointerEvent) => void
    preventMobileScroll?: boolean
}
export function dragger(
    e: HTMLElement,
    { preventMobileScroll, dragging, callback }: Settings
) {
    preventMobileScroll =
        preventMobileScroll !== undefined ? preventMobileScroll : true
    dragging = dragging ? dragging : writable(false)
    const move = (e: PointerEvent) => {
        if (get(dragging)) callback(e)
    }

    const cancel = (evt: TouchEvent) => {
        evt.preventDefault()
    }

    const start = (evt: PointerEvent) => {
        dragging.set(true)
        window.addEventListener("pointercancel", end)
        window.addEventListener("pointerup", end)
        window.addEventListener("pointermove", move)
        if (preventMobileScroll) e.addEventListener("touchmove", cancel)
        callback(evt)
    }
    const end = () => {
        dragging.set(false)
        window.removeEventListener("pointercancel", end)
        window.removeEventListener("pointerup", end)
        window.removeEventListener("pointermove", move)
        if (preventMobileScroll) e.removeEventListener("touchmove", cancel)
    }

    e.addEventListener("pointerdown", start)
    return {
        destroy() {
            window.removeEventListener("pointercancel", end)
            window.removeEventListener("pointerup", end)
            window.removeEventListener("pointermove", move)
            if (preventMobileScroll) e.removeEventListener("touchmove", cancel)
        },
    }
}
